module.exports = __webpack_public_path__ + "static/media/openfactor.81b85dab.png";